export interface FieldSelectOption {
	value: string;
	label: string;
}

export interface FieldSelectProps {
	label: string;
	options: FieldSelectOption[];
	value?: string;
	onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
	id?: string;
	className?: string;
	style?: React.CSSProperties;
}

export function FieldSelect({
	label,
	options,
	value,
	onChange,
	id,
	className,
	style,
}: FieldSelectProps) {
	const selectId =
		id ?? `field-select-${label.toLowerCase().replace(/\s+/g, "-")}`;

	return (
		<div
			className={className}
			style={{
				display: "flex",
				flexDirection: "column",
				gap: 6,
				...style,
			}}
		>
			<label
				htmlFor={selectId}
				style={{
					fontSize: 12,
					fontFamily: "var(--font-mono)",
					fontWeight: 600,
					letterSpacing: "0.08em",
					textTransform: "uppercase",
					color: "var(--color-dashboard-muted)",
				}}
			>
				{label}
			</label>
			<select
				id={selectId}
				value={value}
				onChange={onChange}
				style={{
					height: 40,
					paddingLeft: 14,
					paddingRight: 36,
					fontSize: 14,
					fontFamily: "var(--font-body)",
					color: "var(--color-dashboard-text)",
					background: "var(--color-dashboard-paper)",
					border: "1px solid var(--color-dashboard-border)",
					borderRadius: 7,
					outline: "none",
					cursor: "pointer",
					appearance: "none",
					backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23475569' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`,
					backgroundRepeat: "no-repeat",
					backgroundPosition: "right 12px center",
					transition: "border-color 200ms, box-shadow 200ms",
				}}
				onFocus={(e) => {
					e.currentTarget.style.borderColor = "var(--color-dashboard-accent)";
					e.currentTarget.style.boxShadow =
						"0 0 0 3px color-mix(in srgb, var(--color-dashboard-accent) 12%, transparent)";
				}}
				onBlur={(e) => {
					e.currentTarget.style.borderColor = "var(--color-dashboard-border)";
					e.currentTarget.style.boxShadow = "none";
				}}
			>
				{options.map((opt) => (
					<option key={opt.value} value={opt.value}>
						{opt.label}
					</option>
				))}
			</select>
		</div>
	);
}
